import styled, { css } from 'styled-components';

function CompareTable() {
  return (
    <Container>
      <Col>
        <Header>나만의 알고리즘</Header>
        <Cell>
          <Label>이용방식</Label>
          <Content>상세한 조건입력</Content>
        </Cell>
        <Cell>
          <Label>분석방식</Label>
          <Content>
            알고리즘에 해당하는
            <span>물건 전체 분석</span>
          </Content>
        </Cell>
        <Cell>
          <Label>이용자</Label>
          <Content>
            내가 만든 알고리즘은
            <span>나만 이용가능</span>
          </Content>
        </Cell>
        <Cell>
          <Label>
            이용횟수
            <br />
            (스탠다드 회원 기준)
          </Label>
          <Content>
            <span>무제한</span>
          </Content>
        </Cell>
      </Col>
      <Col>
        <Header $quant>퀀트 분석</Header>
        <Cell>
          <Label>이용방식</Label>
          <Content>12가지 테마 선택</Content>
        </Cell>
        <Cell>
          <Label>분석방식</Label>
          <Content $quant>
            테마에 해당하는
            <span>물건 개별 분석</span>
          </Content>
        </Cell>
        <Cell>
          <Label>이용자</Label>
          <Content $quant>
            스탠다드, 프리미엄 회원
            <span>누구나 이용가능</span>
          </Content>
        </Cell>
        <Cell>
          <Label>
            이용횟수
            <br />
            (스탠다드 회원 기준)
          </Label>
          <Content $quant>
            <span>월 50건</span>
          </Content>
        </Cell>
      </Col>
    </Container>
  );
}

export default CompareTable;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 16px;
  background: #fff;
`;

const Header = styled.div<{ $quant?: boolean }>`
  display: flex;
  height: 56px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-bottom: 2px solid #008aff;

  color: #008aff;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;

  ${({ $quant }) =>
    $quant &&
    css`
      border-color: #4228d6;
      color: #4228d6;
    `}
`;

const Cell = styled.div`
  display: flex;
  height: 96px;
  padding: 16px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const Label = styled.div`
  color: #616161;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Content = styled.div<{ $quant?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  align-self: stretch;

  color: #222;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  & > span {
    align-self: stretch;
    color: ${({ $quant }) => ($quant ? '#1F0A8A' : '#024A88')};
    text-align: center;
    font-weight: 700;
  }
`;
